export default "__VITE_ASSET__BzrLGHOS__"